import store from '../config/store'
import localStorage from '../helpers/mixins/localStorage'

function Guard (to, from, next) {
  let storage = JSON.parse(window.localStorage.getItem(store.localStorageKey))

  if (storage) {
    store.data = storage
  }

  let token = getParameterByName('token_api')
  let route = getParameterByName('route')
  let disposalId = getParameterByName('disposal_id')

    if (token !== null && store.data.user.access_token !== null) {
        store.data = {"user":{"access_token": token },"route": route,"disposalId": disposalId}
        localStorage.methods.saveData()
    }

  window.scrollTo(0, 0);
  next()
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export default Guard
